import React from 'react';
import { Typography, Select, Checkbox } from 'antd';
const IssueCardThreadsync = ({
  showFooterMessage,
  setShowFooterMessage,
  showLinktoWebAppConfig,
  setShowLinktoWebAppConfig,
  showAtMentionReporter,
  setShowAtMentionReporter,
  showRecentComments,
  setShowRecentComments,
  customizationIn,
}) => {
  const { Text } = Typography;
  const { Option } = Select;
  return (
    <>
      <div style={{ marginBottom: '1rem' }}>
        <Text type='secondary'>
          Configure issue card behavior when thread sync is enabled. Thread sync
          is when the slack thread containing the issue card is synching with
          the Jira.
        </Text>
      </div>
      <div style={{ marginBottom: '10px' }}>
        <Checkbox
          checked={showFooterMessage}
          onChange={() => {
            setShowFooterMessage(!showFooterMessage);
          }}
        >
          Footer message mentioning that the slack thread is syncing with Jira.
        </Checkbox>
      </div>
      {customizationIn !== 'personal' && (
        <div style={{ marginBottom: '10px' }}>
          <Checkbox
            checked={showLinktoWebAppConfig}
            onChange={() => {
              setShowLinktoWebAppConfig(!showLinktoWebAppConfig);
            }}
          >
            Show link to customize the thread sync behaviour
          </Checkbox>
        </div>
      )}
      <div style={{ marginBottom: '10px' }}>
        <Checkbox
          checked={showAtMentionReporter}
          onChange={() => {
            setShowAtMentionReporter(!showAtMentionReporter);
          }}
        >
          At-mention reporter and assignee when they are not already following
          the thread.
        </Checkbox>
      </div>
      <div style={{ marginBottom: '10px' }}>
        <Checkbox
          checked={showRecentComments}
          onChange={() => {
            setShowRecentComments(!showRecentComments);
          }}
        >
          Show recent comments added to jira in slack thread.
        </Checkbox>
      </div>
    </>
  );
};
export default IssueCardThreadsync;
